export default class Hero {
    constructor() {
        this.selector = '.hero';
        this.init();
    }

    init() {
        var self = this,
        $hero = $( self.selector );

        if ( $hero.length > 0 ) {            
            $hero.imagesLoaded( { background: '.hero__image' }, function() {
                $( this.elements ).addClass( 'loaded' );
            } );
        }
    }
}